import {teemill} from './teemill';

export const teemillPro = teemill
  .extend('teemillPro')
  .property('primary.color', '#0aadff');
